module.exports = __webpack_public_path__ + "static/media/ProfileTablet.07edb19d.png";